import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type RevealEventPasswordMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type RevealEventPasswordMutation = { __typename?: 'Mutation'; revealEventPassword?: string | null };

export const RevealEventPasswordDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RevealEventPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revealEventPassword' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RevealEventPasswordMutationFn = Apollo.MutationFunction<RevealEventPasswordMutation, RevealEventPasswordMutationVariables>;

/**
 * __useRevealEventPasswordMutation__
 *
 * To run a mutation, you first call `useRevealEventPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevealEventPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revealEventPasswordMutation, { data, loading, error }] = useRevealEventPasswordMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useRevealEventPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RevealEventPasswordMutation, RevealEventPasswordMutationVariables>) {
  return ApolloReactHooks.useMutation<RevealEventPasswordMutation, RevealEventPasswordMutationVariables>(RevealEventPasswordDocument, baseOptions);
}
export type RevealEventPasswordMutationHookResult = ReturnType<typeof useRevealEventPasswordMutation>;
export type RevealEventPasswordMutationResult = Apollo.MutationResult<RevealEventPasswordMutation>;
export type RevealEventPasswordMutationOptions = Apollo.BaseMutationOptions<RevealEventPasswordMutation, RevealEventPasswordMutationVariables>;
